{
  "title": "Asignaciones",
  "status": {
    "pending": "Pendiente",
    "in_progress": "En curso",
    "submitted": "Completada",
    "evaluated": "Evaluada",
    "revoked": "Revocada"
  },
  "table": {
    "respondent": "Destinatario",
    "status": "Estado",
    "brief": "Brief",
    "sent": "Enviada",
    "requester": "Solicitada por",
    "lastReminder": "Último recordatorio",
    "actions": "Acciones",
    "empty": "No se encontraron asignaciones.",
    "self": "Autoperfil"
  },
  "filters": {
    "allStatuses": "Todos los estados",
    "respondentPlaceholder": "Buscar por correo del destinatario",
    "allBriefs": "Todos los briefs"
  },
  "actions": {
    "view": "Ver",
    "remind": "Enviar recordatorio",
    "remindLockout": "Ya se envió un recordatorio en las últimas 24 horas; inténtalo más tarde.",
    "reminded": "Recordatorio enviado",
    "revoke": "Revocar",
    "revokeConfirmTitle": "¿Revocar esta asignación?",
    "revokeConfirmDescription": "La invitación para {{email}} dejará de funcionar de inmediato. Esto no se puede deshacer.",
    "revoked": "Asignación revocada"
  },
  "detail": {
    "title": "Detalle de la asignación",
    "respondent": "Destinatario",
    "requester": "Solicitada por",
    "language": "Idioma",
    "sent": "Enviada",
    "submitted": "Completada",
    "lastReminder": "Último recordatorio",
    "personalMessage": "Mensaje personal",
    "brief": "Brief",
    "selfAssignment": "Autoperfil"
  },
  "send": {
    "title": "Enviar asignaciones",
    "description": "Invita por correo a una o varias personas a completar su perfil.",
    "collapse": "Contraer",
    "expand": "Expandir",
    "emails": "Correos electrónicos",
    "emailsHelp": "Separa varios correos con comas o saltos de línea.",
    "validCount_one": "{{count}} correo válido",
    "validCount_many": "{{count}} correos válidos",
    "validCount_other": "{{count}} correos válidos",
    "invalidList": "Se ignorarán por inválidos: {{list}}",
    "locale": "Idioma",
    "personalMessage": "Mensaje personal (opcional)",
    "brief": "Brief (opcional)",
    "briefPlaceholder": "Sin brief: evaluación genérica",
    "briefSearch": "Buscar briefs",
    "briefEmpty": "No se encontraron briefs.",
    "noBrief": "Sin brief",
    "createBrief": "Crear nuevo brief…",
    "submit_one": "Enviar {{count}} invitación",
    "submit_many": "Enviar {{count}} invitaciones",
    "submit_other": "Enviar {{count}} invitaciones",
    "submitEmpty": "Enviar invitaciones",
    "success": "Invitaciones enviadas"
  },
  "evaluations": {
    "title": "Evaluaciones",
    "empty": "Aún no hay evaluaciones.",
    "respondent": "Persona evaluada",
    "brief": "Brief",
    "submitted": "Completada",
    "view": "Ver evaluación",
    "matrix": "Matriz",
    "evaluation": "Evaluación",
    "publishedAt": "Publicada",
    "notEvaluated": "Esta asignación aún no ha sido evaluada.",
    "back": "Volver a evaluaciones",
    "notFound": "No se encontró la evaluación."
  },
  "dashboard": {
    "sendTitle": "Enviar asignaciones",
    "sendDescription": "Invita por correo a otras personas a completar su perfil para este espacio de trabajo.",
    "sendCta": "Ir a asignaciones",
    "selfTitle": "Crea tu propio perfil",
    "selfDescription": "Responde el cuestionario tú mismo y descubre tu propia matriz.",
    "selfCta": "Comenzar mi perfil",
    "recentTitle": "Asignaciones recientes",
    "recentEmpty": "Todavía no has enviado nada.",
    "viewAll": "Ver todas"
  },
  "consent": {
    "self": "Al comenzar, nos pides que iniciemos de inmediato y renuncias a tu derecho de desistimiento de 14 días sobre este perfil una vez que comienza.",
    "send": "Al enviar, nos pides que iniciemos de inmediato y renuncias a tu derecho de desistimiento de 14 días sobre este perfil una vez que comienza."
  }
}
